(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tva-smart-breadcrumbs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let observer;
    let frame;

    function alignBreadcrumbs() {
      const breadcrumb = document.querySelector('.tva-smart-breadcrumbs');
      const hero = document.querySelector('.tva-product-hero__container');
      if (!breadcrumb || !hero) return;

      const purchase = hero.querySelector('.tva-product-hero__purchase');
      const target = window.matchMedia('(max-width: 749px)').matches && purchase
        ? purchase
        : hero;
      const targetRect = target.getBoundingClientRect();
      if (!targetRect.width) return;

      const breadcrumbRect = breadcrumb.getBoundingClientRect();
      const currentMargin = parseFloat(getComputedStyle(breadcrumb).marginLeft) || 0;
      const leftMargin = currentMargin + targetRect.left - breadcrumbRect.left;
      breadcrumb.style.width = `${targetRect.width}px`;
      breadcrumb.style.maxWidth = 'none';
      breadcrumb.style.marginLeft = `${leftMargin}px`;
      breadcrumb.style.marginRight = '0';
    }

    function scheduleAlignment() {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(alignBreadcrumbs);
    }

    function initializeAlignment() {
      if (observer) observer.disconnect();
      const hero = document.querySelector('.tva-product-hero__container');
      if (!hero) return;
      alignBreadcrumbs();
      if ('ResizeObserver' in window) {
        observer = new ResizeObserver(scheduleAlignment);
        observer.observe(hero);
        const purchase = hero.querySelector('.tva-product-hero__purchase');
        if (purchase) observer.observe(purchase);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAlignment, { once: true });
    } else {
      initializeAlignment();
    }
    window.addEventListener('resize', scheduleAlignment, { passive: true });
    document.addEventListener('shopify:section:load', initializeAlignment);
    document.addEventListener('shopify:section:reorder', initializeAlignment);
  })();

  } catch(e) { console.error(e); }
})();
})();
